// class MarketSwitcher {

//     constructor() {

//         this.switching = false;

//         // Currency → Shopify Country Mapping
//         // Shopify will automatically place the customer
//         // into the correct Market based on country.

//         this.currencyToMarket = {

//             // USA & CA Market
//             USD: 'US',
//             CAD: 'CA',

//             // UK + EU Countries Market
//             EUR: 'DE',
//             GBP: 'GB',

//             // Asia-Pacific Market
//             AUD: 'AU', // Australia
//             INR: 'IN', // India
//             IDR: 'ID', // Indonesia
//             JPY: 'JP', // Japan
//             LKR: 'LK', // Sri Lanka
//             THB: 'TH'  // Thailand

//         };

//     }

//     init() {
//         this.bindCurrencySwitcher();
//     }

//     changeMarket(countryCode) {

//         this.switching = true;

//         const formData = new FormData();

//         formData.append('country_code', countryCode);
//         formData.append('form_type', 'localization');
//         formData.append('_method', 'put');

//         fetch('/localization', {
//             method: 'POST',
//             body: formData
//         })
//         .then(() => {
//             location.reload();
//         })
//         .catch(error => {

//             console.error('Market switch failed:', error);

//             this.switching = false;

//         });

//     }

//     bindCurrencySwitcher() {

//         document.addEventListener('click', (e) => {

//             const item = e.target.closest('.converterTriggers');

//             if (!item || this.switching) return;

//             const currency =
//                 item.getAttribute('rel') ||
//                 item.id;

//             if (!currency) return;

//             const targetCountry =
//                 this.currencyToMarket[currency];

//             if (!targetCountry) {

//                 console.warn(
//                     `No Shopify country mapping found for currency: ${currency}`
//                 );

//                 return;
//             }

//             console.log(
//                 `Currency: ${currency} → Country: ${targetCountry}`
//             );

//             this.changeMarket(targetCountry);

//         });

//     }

// }

// document.addEventListener('DOMContentLoaded', () => {

//     const marketSwitcher = new MarketSwitcher();
//     marketSwitcher.init();

// });

class MarketSwitcher {
    constructor() {
        this.switching = false;

        // Currency → Shopify Country Mapping
        this.currencyToMarket = {
            // USA & CA Market
            USD: 'US',
            CAD: 'CA',

            // UK + EU Market
            EUR: 'DE',
            GBP: 'GB',

            // Asia-Pacific Market
            AUD: 'AU',
            INR: 'IN',
            IDR: 'ID',
            JPY: 'JP',
            MYR: 'MY',
            LKR: 'LK',
            THB: 'TH'
        };
    }

    init() {
        this.bindCurrencySwitcher();
    }

    hideMoney() {
        document
            .querySelectorAll('.money.buckscc-money')
            .forEach((el) => {
                el.style.display = 'none';
            });
    }

    changeMarket(countryCode) {
        this.switching = true;

        const formData = new FormData();

        formData.append('country_code', countryCode);
        formData.append('form_type', 'localization');
        formData.append('_method', 'put');

        fetch('/localization', {
            method: 'POST',
            body: formData
        })
            .then(() => {
                // Reload page after market change
                location.reload();
            })
            .catch((error) => {
                console.error('Market switch failed:', error);

                // Show prices again if request fails
                document
                    .querySelectorAll('.money.buckscc-money')
                    .forEach((el) => {
                        el.style.display = '';
                    });

                this.switching = false;
            });
    }

    bindCurrencySwitcher() {
        document.addEventListener('click', (e) => {
            const item = e.target.closest('.converterTriggers');

            if (!item || this.switching) return;

            const currency =
                item.getAttribute('rel') ||
                item.id;

            if (!currency) return;

            const targetCountry =
                this.currencyToMarket[currency];

            if (!targetCountry) {
                console.warn(
                    `No Shopify country mapping found for currency: ${currency}`
                );
                return;
            }

            console.log(
                `Currency: ${currency} → Country: ${targetCountry}`
            );

            // Hide prices instantly
            this.hideMoney();

            // Switch market via AJAX
            this.changeMarket(targetCountry);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const marketSwitcher = new MarketSwitcher();
    marketSwitcher.init();
});